/* eslint-disable */
import settings from "../../../configs/settings";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import DownloadIcon from "@mui/icons-material/Download";
import { useContext, useEffect, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarArmazonAnteojoSolDialog from "./BuscarArmazonAnteojoSolDialog";
import { getArmazonAnteojoSol } from "../../../project/services/ArticuloService";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const perfilOptions = [
  {
    id: "ancho",
    descripcion: "Ancho",
  },
  {
    id: "fino",
    descripcion: "Fino",
  },
];

const caracteristicaOptions = [
  {
    id: "aro-completo",
    descripcion: "Aro Completo",
  },
  {
    id: "ranurado",
    descripcion: "Ranurado",
  },
  {
    id: "perforado",
    descripcion: "Perforado",
  },
];
//
// ################################################################################
//
const AnteojoAnteojo = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    anteojoTabNuevoDeCliente,
    setAnteojoTabNuevoDeCliente,
    initialAnteojoArmazonNuevo,
    anteojoArmazonNuevo,
    setAnteojoArmazonNuevo,
    handleChangeAnteojoArmazonNuevo,
    initialAnteojoArmazonCliente,
    anteojoArmazonCliente,
    setAnteojoArmazonCliente,
    handleChangeAnteojoArmazonCliente,
    anteojoCristales,
    gaAction,
  } = useContext(GestionAtencionContext);

  let {
    anteojoArmazonNuevoCodigoArmazon,
    anteojoArmazonNuevoDescripcionArmazon,
    anteojoArmazonNuevoMarcaArmazon,
    anteojoArmazonNuevoModeloArmazon,
    anteojoArmazonNuevoCategoriaArmazon,
    anteojoArmazonNuevoMaterialArmazon,
    anteojoArmazonNuevoFormatoArmazon,
    anteojoArmazonNuevoCalibreArmazon,
    anteojoArmazonNuevoTipoArmazon,
    anteojoArmazonNuevoColorLenteArmazon,
    anteojoArmazonNuevoPrecioVentaArmazon,
    // anteojoArmazonNuevoPrecioVentaOriginalArmazon,
    // anteojoArmazonNuevoPorcentajeDescuentoArmazon,
    anteojoArmazonNuevoPrecioVentaContadoArmazon,
  } = anteojoArmazonNuevo;

  let {
    anteojoArmazonClienteDejaSuAnteojo,
    anteojoArmazonClienteDescripcion,
    anteojoArmazonClienteDistanciaHorizontal,
    anteojoArmazonClienteDistanciaVertical,
    anteojoArmazonClienteDistanciaDiagonal,
    anteojoArmazonClienteDistanciaPuente,
    anteojoArmazonClienteDistanciaMayor,
    anteojoArmazonClientePerfil,
    anteojoArmazonClienteCaracteristica,
    anteojoArmazonClienteBase,
  } = anteojoArmazonCliente;

  let {
    anteojoCristalesSolictaDatosMonturaClienteOD,
    anteojoCristalesSolictaDatosMonturaClienteOI,
  } = anteojoCristales;
  //
  // ################################################################################
  //
  useEffect(() => {
    if (anteojoTabNuevoDeCliente === 0) {
      setAnteojoArmazonCliente(initialAnteojoArmazonCliente);
    } else {
      setAnteojoArmazonNuevo(initialAnteojoArmazonNuevo);
    }
  }, [
    anteojoTabNuevoDeCliente,
    setAnteojoArmazonCliente,
    initialAnteojoArmazonCliente,
    setAnteojoArmazonNuevo,
    initialAnteojoArmazonNuevo,
  ]);
  //
  // ################################################################################
  // en anteojo del cliente, cuando el usuario indica que el cliente no deja su anteojo
  useEffect(() => {
    if (anteojoArmazonClienteDejaSuAnteojo) {
      setAnteojoArmazonCliente(initialAnteojoArmazonCliente);
    }
  }, [anteojoArmazonClienteDejaSuAnteojo, initialAnteojoArmazonCliente, setAnteojoArmazonCliente]);
  //
  // ################################################################################
  //
  const handleChangeTab = (event, newValue) => {
    setAnteojoTabNuevoDeCliente(newValue);
  };
  //
  // ################################################################################
  //
  const handleBuscarArmazonAnteojoSol = () => {
    if (anteojoArmazonNuevoCodigoArmazon === "") {
      return;
    }
    buscarArmazonAnteojoSol(anteojoArmazonNuevoCodigoArmazon);
  };
  //
  // ################################################################################
  //
  const buscarArmazonAnteojoSol = async (parArmazonNuevoCodigoArmazon) => {

    parArmazonNuevoCodigoArmazon = limpiaCodigo(parArmazonNuevoCodigoArmazon).toUpperCase();

    setAnteojoArmazonNuevo({
      ...anteojoArmazonNuevo,
      anteojoArmazonNuevoCodigoArmazon: parArmazonNuevoCodigoArmazon,
    });

    let _params = {
      codigo: parArmazonNuevoCodigoArmazon,
      valida_existencia: 'S',
    };

    setIsDoingSomething(true);
    const response = await getArmazonAnteojoSol(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _params = {
        tipoArticulo: response.data.data[0].descripcion_tipo_articulo,
        id: response.data.data[0].id_ar_as_marca,
      };

      setIsDoingSomething(true);
      const responseDescuento = await getPorcentajeDescuento(_params);
      setIsDoingSomething(false);

      let _porcentajeDescuento = 0;
      if (responseDescuento.ok) {
        _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
      }
      let _precioVentaContado = response.data.data[0].precio_venta_lista - (response.data.data[0].precio_venta_lista * _porcentajeDescuento) / 100;

      const _armazonAnteojoSol = {
        anteojoArmazonNuevoIdArmazon: response.data.data[0].id,
        anteojoArmazonNuevoCodigoArmazon: response.data.data[0].codigo,
        anteojoArmazonNuevoDescripcionArmazon: response.data.data[0].descripcion,
        anteojoArmazonNuevoMarcaArmazon: response.data.data[0].descripcion_ar_as_marca,
        anteojoArmazonNuevoModeloArmazon: response.data.data[0].modelo,
        anteojoArmazonNuevoCategoriaArmazon: response.data.data[0].descripcion_ar_as_categoria,
        anteojoArmazonNuevoMaterialArmazon: response.data.data[0].descripcion_ar_as_material,
        anteojoArmazonNuevoFormatoArmazon: response.data.data[0].descripcion_ar_as_formato,
        anteojoArmazonNuevoCalibreArmazon: response.data.data[0].valor_ar_as_calibre,
        anteojoArmazonNuevoTipoArmazon: response.data.data[0].descripcion_ar_as_tipo,
        anteojoArmazonNuevoColorLenteArmazon: response.data.data[0].descripcion_as_color_lente || "",
        anteojoArmazonNuevoPrecioVentaArmazon: response.data.data[0].precio_venta_lista,
        anteojoArmazonNuevoPrecioVentaOriginalArmazon: response.data.data[0].precio_venta_lista,
        anteojoArmazonNuevoPorcentajeDescuentoArmazon: _porcentajeDescuento,
        anteojoArmazonNuevoPrecioVentaContadoArmazon: _precioVentaContado,
        anteojoArmazonClienteDescripcion: "",
        anteojoArmazonClienteDistanciaHorizontal: 0,
        anteojoArmazonClienteDistanciaVertical: 0,
        anteojoArmazonClienteDistanciaDiagonal: 0,
        anteojoArmazonClienteDistanciaPuente: 0,
        anteojoArmazonClienteDistanciaMayor: 0,
        anteojoArmazonClientePerfil: "",
        anteojoArmazonClienteCaracteristica: "",
        anteojoArmazonClienteBase: "0",
        anteojoArmazonClienteDejaSuAnteojo: false,
      };
      setAnteojoArmazonNuevo(_armazonAnteojoSol);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
      setAnteojoArmazonNuevo(initialAnteojoArmazonNuevo);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);
    buscarArmazonAnteojoSol(articulo.codigo);
  };
  //
  // ################################################################################
  //
  const handleLimpiarArmazonNuevo = () => {
    setAnteojoArmazonNuevo(initialAnteojoArmazonNuevo);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Tabs
        value={anteojoTabNuevoDeCliente}
        onChange={handleChangeTab}
        aria-label="basic tabs example"
      >
        <Tab label="Nuevo" disabled={gaAction.cu === "view" ? true : false} />
        <Tab label="De Cliente" disabled={gaAction.cu === "view" ? true : false} />
      </Tabs>
      <Box sx={{ m: 1, px: 1, pb: 1 }}>
        {anteojoTabNuevoDeCliente === 0 && (
          // anteojo nuevo
          <>
            <Grid container spacing={1}>
              <Grid item md={6}>

                {/* codigo de armazon */}

                <TextField
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo-armazon"
                  label="Código del Armazón"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoCodigoArmazon"
                  value={anteojoArmazonNuevoCodigoArmazon}
                  onChange={handleChangeAnteojoArmazonNuevo}
                  disabled={anteojoArmazonNuevoDescripcionArmazon !== ""}
                />
              </Grid>

              {gaAction.cu !== "view" && (
                <>
                  <Grid item md={6}>
                    {/* boton buscar */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      onClick={handleBuscarArmazonAnteojoSol}
                      startIcon={<SearchIcon />}
                      disabled={
                        anteojoArmazonNuevoCodigoArmazon === "" ||
                        anteojoArmazonNuevoDescripcionArmazon !== ""
                      }
                    >
                      Buscar
                    </Button>

                    {/* boton busqueda avanzada */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      onClick={handleClickOpenBusquedaAvanzada}
                      startIcon={<SavedSearchIcon />}
                    >
                      Búsqueda Avanzada
                    </Button>

                    {/* boton limpiar */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="outlined"
                      onClick={handleLimpiarArmazonNuevo}
                      startIcon={<CleaningServicesIcon />}
                      disabled={anteojoArmazonNuevoCodigoArmazon === ""}
                    >
                      Limpiar
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid container spacing={1}>
              <Grid item md={6}>
                {/* descripcion del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="descripcion-armazon"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoDescripcionArmazon"
                  value={anteojoArmazonNuevoDescripcionArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* marca del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="marca-armazon"
                  label="Marca"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoMarcaArmazon"
                  value={anteojoArmazonNuevoMarcaArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* modelo del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="modelo-armazon"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoModeloArmazon"
                  value={anteojoArmazonNuevoModeloArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* categoria del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="categoria-armazon"
                  label="Categoría"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoCategoriaArmazon"
                  value={anteojoArmazonNuevoCategoriaArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* material del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="material-armazon"
                  label="Material"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoMaterialArmazon"
                  value={anteojoArmazonNuevoMaterialArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* formato del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="formato-armazon"
                  label="Formato"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoFormatoArmazon"
                  value={anteojoArmazonNuevoFormatoArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* calibre del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="calibre-armazon"
                  label="Calibre"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoCalibreArmazon"
                  value={anteojoArmazonNuevoCalibreArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* tipo del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="tipo-armazon"
                  label="Tipo"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoTipoArmazon"
                  value={anteojoArmazonNuevoTipoArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* color del lente del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="color-lente-armazon"
                  label="Color de Lente"
                  variant="outlined"
                  size="small"
                  name="anteojoArmazonNuevoColorLenteArmazon"
                  value={anteojoArmazonNuevoColorLenteArmazon}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item sm={6}>
                {/* total del armazon */}
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "LightBlue",
                    borderRadius: "5px",
                    fontWeight: "bold",
                  }}
                >
                  PRECIO DE LISTA: {formatMoney(anteojoArmazonNuevoPrecioVentaArmazon)}
                </Typography>
              </Grid>
              <Grid item sm={6}>
                {/* total del armazon */}
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "LightBlue",
                    borderRadius: "5px",
                    fontWeight: "bold",
                  }}
                >
                  PRECIO DE CONTADO: {formatMoney(anteojoArmazonNuevoPrecioVentaContadoArmazon)}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
        {anteojoTabNuevoDeCliente === 1 && (
          // anteojo de cliente
          <>
            <Grid container spacing={1}>
              <Grid item md={6}>
                <FormGroup>
                  {/* cliente deja su anteojo */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="anteojoArmazonClienteDejaSuAnteojo"
                        checked={anteojoArmazonClienteDejaSuAnteojo}
                        onChange={handleChangeAnteojoArmazonCliente}
                      />
                    }
                    label="El Cliente deja su anteojo"
                  />
                </FormGroup>
              </Grid>
            </Grid>

            {/* si el cliente no deja su anteojo y (si el cristal del ojo izquierdo no es de stock o el cristal del ojo derecho no es de stock)*/}
            {!anteojoArmazonClienteDejaSuAnteojo &&
              (anteojoCristalesSolictaDatosMonturaClienteOD ||
                anteojoCristalesSolictaDatosMonturaClienteOI) && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    {/* descripcion del anteojo del cliente */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-descripcion"
                      label="Estado de la montura"
                      multiline
                      maxRows={3}
                      name="anteojoArmazonClienteDescripcion"
                      value={anteojoArmazonClienteDescripcion}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  {/* <Grid item xs={0} md={2} sx={{border:"1px solid, red"}}>a</Grid> */}
                  <Grid item md={2}>
                    {/* distancia horizontal */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-distancia-horizontal"
                      label="Horizonal"
                      variant="outlined"
                      size="small"
                      name="anteojoArmazonClienteDistanciaHorizontal"
                      value={anteojoArmazonClienteDistanciaHorizontal}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  <Grid item md={2}>
                    {/* distancia vertical */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-distancia-vertical"
                      label="Vertical"
                      variant="outlined"
                      size="small"
                      name="anteojoArmazonClienteDistanciaVertical"
                      value={anteojoArmazonClienteDistanciaVertical}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  <Grid item md={2}>
                    {/* distancia diagonal */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-distancia-diagonal"
                      label="Diagonal"
                      variant="outlined"
                      size="small"
                      name="anteojoArmazonClienteDistanciaDiagonal"
                      value={anteojoArmazonClienteDistanciaDiagonal}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  <Grid item md={2}>
                    {/* distancia puente */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-distancia-puente"
                      label="Puente"
                      variant="outlined"
                      size="small"
                      name="anteojoArmazonClienteDistanciaPuente"
                      value={anteojoArmazonClienteDistanciaPuente}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  <Grid item md={2}>
                    {/* distancia diagonal mayor */}
                    <TextField
                      sx={{ width: "100%", mb: 1 }}
                      id="armazon-cliente-distancia-mayor"
                      label="Mayor"
                      variant="outlined"
                      size="small"
                      name="anteojoArmazonClienteDistanciaMayor"
                      value={anteojoArmazonClienteDistanciaMayor}
                      onChange={handleChangeAnteojoArmazonCliente}
                    />
                  </Grid>
                  <Grid item md={6}>
                    {/* perfil */}
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="armazon-cliente-perfil">Perfil</InputLabel>
                      <Select
                        labelId="armazon-cliente-perfil"
                        id="armazon-cliente-perfil"
                        name="anteojoArmazonClientePerfil"
                        value={anteojoArmazonClientePerfil}
                        label="Perfil"
                        size="small"
                        onChange={handleChangeAnteojoArmazonCliente}
                      >
                        {perfilOptions.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6}>
                    {/* caracteristica */}
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="armazon-cliente-caracteristica">Característica</InputLabel>
                      <Select
                        labelId="armazon-cliente-caracteristica"
                        id="armazon-cliente-caracteristica"
                        name="anteojoArmazonClienteCaracteristica"
                        value={anteojoArmazonClienteCaracteristica}
                        label="Característica"
                        size="small"
                        onChange={handleChangeAnteojoArmazonCliente}
                      >
                        {caracteristicaOptions.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6}>
                    {/* base */}
                    <FormControl>
                      <FormLabel id="controlled-radio-buttons-group">Base</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="controlled-radio-buttons-group"
                        name="anteojoArmazonClienteBase"
                        value={anteojoArmazonClienteBase}
                        onChange={handleChangeAnteojoArmazonCliente}
                      >
                        <FormControlLabel value="0" control={<Radio />} label="0" />
                        <FormControlLabel value="2" control={<Radio />} label="2" />
                        <FormControlLabel value="4" control={<Radio />} label="4" />
                        <FormControlLabel value="6" control={<Radio />} label="6" />
                        <FormControlLabel value="8" control={<Radio />} label="8" />
                        <FormControlLabel value="10" control={<Radio />} label="10" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item md={6}>
                    {/* boton para descargar formulario */}
                    <Button
                      sx={{ mt: 1, mr: 1, mb: 3 }}
                      variant="contained"
                      // onClick={...}
                      startIcon={<DownloadIcon />}
                    >
                      Formulario de datos del anteojo
                    </Button>
                  </Grid>
                </Grid>
              )}
          </>
        )}
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarArmazonAnteojoSolDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AnteojoAnteojo;
